import React from "react";
import { catalogLabel } from "./constants";

const ChipGroup = ({ title, items = [], selectedIds = [], onToggle }) => (
  <div className="flex flex-col gap-2">
    <h4 className="text-sm font-semibold text-secondaryColor">{title}</h4>
    <div className="flex flex-wrap gap-2">
      {items.length === 0 ? (
        <p className="text-sm text-amber-700">No enabled options.</p>
      ) : (
        items.map((item) => {
          const on = selectedIds.includes(item.id);
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onToggle(item.id)}
              className={`rounded-md border px-3 py-1.5 text-sm transition-colors ${
                on
                  ? "border-secondaryColor bg-secondaryColor text-white"
                  : "border-gray-400 bg-white text-gray-700 dark:border-gray-600 dark:bg-darkBg2 dark:text-[#c7d8eb]"
              }`}
            >
              {catalogLabel(item)}
            </button>
          );
        })
      )}
    </div>
  </div>
);

export default ChipGroup;
